import { isSupabaseConfigured, supabase } from '@/lib/supabase'

export type InquiryAudience = 'shelf_owner' | 'brand'

export const phonePattern = '^[+0-9\\s()-]{10,18}$'

export const normalizeIndianMobile = (value: string) => {
  const compactValue = value.replace(/[\s()-]/g, '')
  const withoutCountryCode = compactValue
    .replace(/^\+91/, '')
    .replace(/^91(?=[6-9]\d{9}$)/, '')
    .replace(/^0(?=[6-9]\d{9}$)/, '')

  return withoutCountryCode
}

export const isValidIndianMobile = (value: string) => /^[6-9]\d{9}$/.test(normalizeIndianMobile(value))

export const getIndianMobileError = (value: string) => {
  if (!value.trim()) {
    return ''
  }

  return isValidIndianMobile(value) ? '' : 'Enter a valid 10 digit Indian mobile number.'
}

export const isValidEmail = (value: string) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value.trim())

export const getEmailError = (value: string) => {
  if (!value.trim()) {
    return ''
  }

  return isValidEmail(value) ? '' : 'Enter a valid email address.'
}

export const isValidWebsiteUrl = (value: string) => {
  if (!value.trim()) {
    return true
  }

  try {
    const url = new URL(value)
    return url.protocol === 'http:' || url.protocol === 'https:'
  } catch {
    return false
  }
}

export const getWebsiteUrlError = (value: string) => {
  if (!value.trim()) {
    return ''
  }

  return isValidWebsiteUrl(value) ? '' : 'Enter a valid website URL, e.g. https://brand.com.'
}

export const submitInquiry = async (audience: InquiryAudience, payload: Record<string, string>) => {
  if (!isSupabaseConfigured || !supabase) {
    throw new Error('Supabase is not configured for this environment.')
  }

  const { error } = await supabase.from('inquiries').insert({
    audience,
    payload,
  })

  if (error) {
    throw error
  }
}
